export class TorchKpiInjuryMonthlyRates {
  id: number;
  injuryDate: Date;
  injuryRatePer200kManHrs: number;
}
